module.exports = __webpack_public_path__ + "static/media/boris.daaa0a83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/decoration/img/boris.jpg
// module id = 738
// module chunks = 0